module.exports = __webpack_public_path__ + "img/s2-4.1936e551.jpg";